import React from 'react';
import LogosSVGs from '../../assets/images/logos';
import { getSubdomain } from '../../helpers/utils';
import LulaLogo from '../../assets/images/lula-logo.svg';

const Header = () => (
  <div className="main-header">
    <div className="container">
      <div className="main-header--inner">
        {LogosSVGs?.[getSubdomain()] || ''}
        <div className="powered-by">
          Powered by
          <img src={LulaLogo} alt="" />
        </div>
      </div>
    </div>
  </div>
);

export default Header;
